import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Grid, Form, Button, Accordion, Icon } from 'semantic-ui-react';
import { GenericFiltersContainer } from 'Components/filters/container';
import { ITEM_MAINTENANCE_FORM } from 'Common/FormEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { ItemMaintenanceEnum } from 'Common/FieldEnum';
import { CheckboxField } from 'Common/SemanticWrapper';

class ItemMaintenanceForm extends Component {
  render() {
    const {
      handleChangeAccordion,
      accordionActiveIndex,
      fields,
      handleChange,
      filterValues,
      clearFilters,
      activeStatusOptions,
    } = this.props;
    return (
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={!accordionActiveIndex}
            index={0}
            onClick={handleChangeAccordion}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={!accordionActiveIndex}>
            <Grid className={'remove-spacing'}>
              <GenericFiltersContainer
                fields={fields}
                onChange={handleChange}
                filterValues={filterValues}
              />
              <Grid.Row
                columns={3}
                style={{
                  marginTop: 16,
                }}
              >
                <Grid.Column verticalAlign={'bottom'}>
                  <ReduxFormButtonGroup
                    options={activeStatusOptions}
                    formName={ITEM_MAINTENANCE_FORM}
                    fieldName={ItemMaintenanceEnum.ActiveStatus}
                    type={'button'}
                    onChange={handleChange}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={CheckboxField}
                    name={ItemMaintenanceEnum.PrepareInHouse}
                    toggle={true}
                    label={'Kitchen Item'}
                    onChange={handleChange}
                  />
                </Grid.Column>
                <Grid.Column textAlign={'right'}>
                  <Button
                    className={'clear-filters-button'}
                    content="Clear Filters"
                    onClick={clearFilters}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
      </Form>
    );
  }
}

export default reduxForm({
  form: ITEM_MAINTENANCE_FORM,
  destroyOnUnmount: false,
})(ItemMaintenanceForm);



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/components/ItemMaintenanceForm.js